(function () {
  function removeStorewideBundleWidget() {
    document.querySelectorAll('.lp-purchase .bx-widget-container').forEach(function (widget) {
      widget.remove();
    });
    document.querySelectorAll('#sticky_add_to_cart_root, #bundle-sticky_add_to_cart').forEach(function (widget) {
      widget.remove();
    });
    if (document.body) document.body.style.paddingBottom = '0';
  }

  function setInitialQuantity() {
    document.querySelectorAll('.js-lp-product-form').forEach(function (form) {
      if (form.dataset.lpInitialQuantitySet) return;
      var quantity = form.querySelector('[data-lp-qty]');
      if (quantity) quantity.value = '1';
      form.dataset.lpInitialQuantitySet = 'true';
    });
  }

  function initialise() {
    removeStorewideBundleWidget();
    setInitialQuantity();
    new MutationObserver(removeStorewideBundleWidget).observe(document.body, {
      childList: true,
      subtree: true
    });
    [50, 250, 800].forEach(function (delay) {
      window.setTimeout(function () {
        removeStorewideBundleWidget();
        setInitialQuantity();
      }, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }
}());